export default __webpack_public_path__ + "static/media/emptyTest.21db927d.svg";